import React from 'react';
import {Col, Form, Row} from 'react-bootstrap';
import {BpmAnimationSelect} from '../../../../system/BpmAnimationSelect/BpmAnimationSelect';
import Ranges from '../../../../system/ranges';
import {NewFontManager} from '../../../../system/NewFontManager/NewFontManager';
import ColorPicker from '../ColorPicker';
import {BPM_ANIMATION_MODE} from '@pulsoid-private/widgets-lib';

export const BpmConfiguration = ({configuration, updateConfiguration}) => {
  const isRangeAnimation =
    configuration.animation?.mode === BPM_ANIMATION_MODE.RANGE;

  return (
    <>
      <h4>BPM Configuration</h4>

      <NewFontManager
        font={configuration.font}
        fontUrl={configuration.fontUrl}
        onChange={(font) => updateConfiguration({font})}
        withUpload
      />

      <Form.Group as={Row}>
        <Form.Label column htmlFor="animation" sm="2">
          Icon Animation
        </Form.Label>
        <Col sm="3">
          <Form.Switch
            style={{marginTop: 7}}
            id="animation"
            defaultChecked={
              configuration.animation?.mode === BPM_ANIMATION_MODE.RANGE
            }
            onChange={(e) =>
              updateConfiguration({
                animation: {
                  ...configuration.animation,
                  mode: e.currentTarget.checked
                    ? BPM_ANIMATION_MODE.RANGE
                    : BPM_ANIMATION_MODE.NONE,
                },
              })
            }
          />
        </Col>
      </Form.Group>

      <Row>&nbsp;</Row>
      <Row>&nbsp;</Row>

      <Form.Group>
        <Ranges
          ranges={configuration.ranges}
          onRangesChange={(ranges) => updateConfiguration({ranges})}
          defaultRange={{
            from: 60,
            to: 90,
            color: '#11a2b1ff',
          }}
          header={
            <Col md={3}>
              <Form inline>
                <Col>Color</Col>
              </Form>
            </Col>
          }
          rangeConfiguration={(range, onRangeChange) => (
            <Col md={isRangeAnimation ? 5 : 3} key={range.from}>
              <Row>
                <Col>
                  <Form inline>
                    <ColorPicker
                      color={range.color}
                      onChangeComplete={(color) =>
                        onRangeChange({
                          ...range,
                          color,
                        })
                      }
                    />
                  </Form>
                </Col>
                {isRangeAnimation ? (
                  <Col>
                    <Form inline>
                      <BpmAnimationSelect
                        onChange={(e) =>
                          onRangeChange({...range, animation: e})
                        }
                        value={range.animation}
                      />
                    </Form>
                  </Col>
                ) : null}
              </Row>
            </Col>
          )}
        />
      </Form.Group>
    </>
  );
};
